import { ReactNode } from 'react';
import { CustomerInformationContainerProps } from '@msc-b2c/interfaces/types';

import { CustomerInformationContainer } from './CustomerInformationContainer';
import { usePrivateAreaPageViewTracking } from '../utils/analyticsUtils';

export function CustomerInformationContainerWrapper({
  dataComponentName,
  passwordSectionTitleIcon,
  passwordSectionTitle,
  passwordSectionCtaLabel,
  passwordSectionCtaLink,
  fullLoginAuthenticationExchangePage,
  phoneAndEmailSectionTitleIcon,
  phoneAndEmailSectionTitle,
  phoneAndEmailSectionCtaLabel,
  emailLabel,
  phoneNumberLabel,
  mobileNumberLabel,
  addressSectionTitleIcon,
  addressSectionTitle,
  addressSectionCtaLabel,
  addressLabel,
  cityLabel,
  postalCodeLabel,
  verifyZipCodeButtonEnabled,
  verifyZipCodeButtonLabel,
  stateLabel,
  privacySectionTitleIcon,
  privacySectionTitle,
  privacySectionCtaLabel,
  enableCheckboxTitleAndSubtitle = false,
  privacyAgreementText,
  formPrivacyFields,
  popupPrivacyTitle,
  popupPrivacyCloseIcon,
  formAddressFields,
  popupAddressTitle,
  popupAddressCloseIcon,
  formPhoneEmailFields,
  popupPhoneEmailTitle,
  popupPhoneEmailCloseIcon,
  popupPrivacySubmitButtonLabel,
  popupPrivacyCancelButtonLabel,
  popupAddressSubmitButtonLabel,
  popupAddressCancelButtonLabel,
  popupPhoneEmailSubmitButtonLabel,
  popupPhoneEmailCancelButtonLabel,
  errorCtaLabel,
  errorClosingIcon,
  errors,
}: Readonly<CustomerInformationContainerProps>): ReactNode {
  usePrivateAreaPageViewTracking();

  const props = {
    dataComponentName,
    passwordSectionTitleIcon,
    passwordSectionTitle,
    passwordSectionCtaLabel,
    passwordSectionCtaLink,
    fullLoginAuthenticationExchangePage,
    phoneAndEmailSectionTitleIcon,
    phoneAndEmailSectionTitle,
    phoneAndEmailSectionCtaLabel,
    emailLabel,
    phoneNumberLabel,
    mobileNumberLabel,
    addressSectionTitleIcon,
    addressSectionTitle,
    addressSectionCtaLabel,
    addressLabel,
    cityLabel,
    postalCodeLabel,
    verifyZipCodeButtonEnabled,
    verifyZipCodeButtonLabel,
    stateLabel,
    privacySectionTitleIcon,
    privacySectionTitle,
    privacySectionCtaLabel,
    enableCheckboxTitleAndSubtitle,
    privacyAgreementText,
    formPrivacyFields,
    popupPrivacyTitle,
    popupPrivacyCloseIcon,
    formAddressFields,
    popupAddressTitle,
    popupAddressCloseIcon,
    formPhoneEmailFields,
    popupPhoneEmailTitle,
    popupPhoneEmailCloseIcon,
    popupPrivacySubmitButtonLabel,
    popupPrivacyCancelButtonLabel,
    popupAddressSubmitButtonLabel,
    popupAddressCancelButtonLabel,
    popupPhoneEmailSubmitButtonLabel,
    popupPhoneEmailCancelButtonLabel,
    errorCtaLabel,
    errorClosingIcon,
    errors,
  };

  return <CustomerInformationContainer {...props} />;
}

CustomerInformationContainerWrapper.aemResourceType =
  'b2c-website-foundation/components/mymsc/customerinformationcontainer';

export default CustomerInformationContainerWrapper;
